export default "__VITE_ASSET__6aa96aa3__"